import { useContext } from 'react'
import { Button } from '@/components/ui/button'
import GoogleIcon from '../assets/svgIcons/google_icon.svg'
import { AuthContext } from '../contexts/AuthContext'
import { cn } from '@/lib/utils'

interface GoogleLoginButtonProps {
    marginTop?: number | string
    fontSize?: 'sm' | 'md' | 'lg'
}

const GoogleLoginButton = ({
    marginTop,
    fontSize = 'md',
}: GoogleLoginButtonProps) => {
    const { kalviumKc } = useContext(AuthContext)

    const fontSizeClasses = {
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
    }

    return (
        <Button
            variant="outline"
            className={cn(
                'flex items-center gap-4 h-auto py-3 px-4 border-gray-800 dark:border-[#333333] bg-white dark:bg-white text-gray-800 dark:text-gray-900 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-100 dark:hover:text-gray-900 hover:border-gray-900 dark:hover:border-gray-400 transition-colors',
                fontSizeClasses[fontSize]
            )}
            style={{ marginTop }}
            onClick={() => {
                kalviumKc.doLogin()
            }}
        >
            <img src={GoogleIcon} alt="Google" className="h-6 w-6" />
            <span className="font-normal">Continue with Google</span>
        </Button>
    )
}

export default GoogleLoginButton
